/**
 * A per-column CTA is often a generic "Shop now", so its accessible name has
 * to say which column it shops. It starts with the visible label so a voice
 * user can still say what they see, and it is left alone when the label
 * already names the item.
 */
export const getCtaAriaLabel = (
  label: string,
  name: string,
  format: (values: { label: string; name: string }) => string
): string | undefined => {
  if (!name) return undefined;
  if (label.toLocaleLowerCase().includes(name.toLocaleLowerCase())) {
    return undefined;
  }
  return format({ label, name });
};
